import {React, useContext} from 'external/react'
import {styled} from 'external/material'
import create from 'helpers/command'

import Dialog from './Dialog'

import {TeacherContext} from 'teacher/context'

const StyledDeleteGrade = styled(Dialog)(deleteGradeStyles)


export default function DeleteExternalGrade() {

    const context = useContext(TeacherContext)

    const {updateState, rollbookContextDeleteGrade: {open, grade}} = context
    
    function onClose() {
        updateState({rollbookContextDeleteGrade: { open: {$set: false}, grade: {$set: undefined}}})
        
    }

    async function onConfirm() {
      const [deletedId] = await create('grading', 'deleteExternalGrade')({id: grade.id})
      context.updateState({rollbookContext: {gradeColumns: {refreshes: {$apply: i => i + 1}}, grades: {refreshes: {$apply: i => i + 1}}}})
      onClose()
    }

    const shouldConfirm = grade ? grade.turnIns > 0 : false
    const notificationId = shouldConfirm ? 'new-grade-delete' : 'grade-delete'

    return <StyledDeleteGrade {...{open, context, onClose, onConfirm, shouldConfirm, notificationId}} />
}

function deleteGradeStyles() {
    return {}
}
